import Request from '@/core/QuRequest';
// import * as $cache from '@/common/cache';

const req = new Request();

export default {
  methods: {
    // 获取产品名称
    async queryProductName(name) {
      const params = { name };
      try {
        const data = await req.send(
          req.Apis.sales.report.productReportSearch,
          params,
        );
        return data.data;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    getParams() {
      const [start, end] = this.baseDate;
      const params = {
        start_date: start.format(this.$REQUEST_DATE_FORMAT),
        end_date: end.format(this.$REQUEST_DATE_FORMAT),
        product_id: this.productId,
        // product_id: 7829,
      };

      // 对比时间
      if (this.contrastDate) {
        const [start, end] = this.contrastDate;
        params.compare_start_date = start.format(this.$REQUEST_DATE_FORMAT);
        params.compare_end_date = end.format(this.$REQUEST_DATE_FORMAT);
      }

      return params;
    },

    // 获取折线图
    async queryPrecisionLine() {
      const params = this.getParams();
      params.dimension = this.summaryDate;
      params.indexes = this.trendOptions.join(',');
      params.app_marketing_type = this.marketingType;
      try {
        const data = await req.send(
          req.Apis.sales.report.productReportPrecisionLine,
          params,
        );
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取饼图
    async queryPrecisionPie() {
      const params = this.getParams();
      params.chart_type = this.proType;
      params.dimension = this.proportionDimension;
      params.indexes = this.trendOptions[0];
      params.app_marketing_type = this.marketingType;
      try {
        const data = await req.send(
          req.Apis.sales.report.productReportPrecisionPie,
          params,
        );
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取表格
    async queryPrecisionList() {
      const params = this.getParams();
      params.order_by = this.order;
      params.fields = this.fields.join(',');
      params.filters = this.filters;
      params.dimension = this.summaryDate;
      params.page = this.page;
      params.page_size = this.pageSize;
      params.app_marketing_type = this.marketingType;

      try {
        const data = await req.send(
          req.Apis.sales.report.productReportPrecisionList,
          params,
        );
        this.rawTableData = data.data;
        this.tableLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    async download() {
      // const form = document.createElement('form');
      // form.id = 'downloadForm';
      // form.name = 'tableDownloadHelper';
      // document.body.appendChild(form);
      // for (let key in params) {
      //   if (params.hasOwnProperty(key)) {
      //     if (key !== 'filters') {
      //       const input = document.createElement('input');
      //       input.type = 'hidden';
      //       input.name = key;
      //       input.value = params[key];
      //       form.appendChild(input);
      //     } else {
      //       params[key].forEach((value) => {
      //         const input = document.createElement('input');
      //         input.type = 'hidden';
      //         input.name = 'filters[]';
      //         input.value = value;
      //         form.appendChild(input);
      //       });
      //     }
      //   }
      // }
      // form.method = 'POST';
      // form.action = req.getUrl(req.Apis.sales.report.productReportPrecisionDownload);
      // form.submit();
      // document.body.removeChild(form);
    },
  },
};
